import { render, staticRenderFns } from "./TabsPrimary.vue?vue&type=template&id=49f7c531&scoped=true&"
import script from "./TabsPrimary.vue?vue&type=script&lang=js&"
export * from "./TabsPrimary.vue?vue&type=script&lang=js&"
import style0 from "./TabsPrimary.vue?vue&type=style&index=0&id=49f7c531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7c531",
  null
  
)

export default component.exports